import { render, staticRenderFns } from "./pi-home-map-screen-other.vue?vue&type=template&id=6bec78b8&"
import script from "./pi-home-map-screen-other.vue?vue&type=script&lang=ts&"
export * from "./pi-home-map-screen-other.vue?vue&type=script&lang=ts&"
import style0 from "./pi-home-map-screen-other.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports